import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';
import { useCurrentModule } from '@/hooks/useCurrentModule';
import { handleSupabaseError } from '@/lib/errors/handleSupabaseError';

export interface UserPoints {
  total_points: number;
  weekly_points: number;
  monthly_points: number;
  current_level: number;
}

export function useUserPoints() {
  const { user } = useAuth();
  const moduleType = useCurrentModule();

  return useQuery<UserPoints | null>({
    queryKey: ['user-points', user?.id, moduleType],
    enabled: !!user,
    staleTime: 60_000,
    queryFn: async () => {
      if (!user) return null;
      const { data, error } = await supabase
        .from('user_points')
        .select('total_points, weekly_points, monthly_points, current_level')
        .eq('user_id', user.id)
        .eq('module_type', moduleType)
        .maybeSingle();
      if (error) {
        handleSupabaseError(error, undefined, { context: { source: 'useUserPoints' }, silent: true });
        return null;
      }
      return data;
    },
  });
}
